// src/pages/PageSupprimerEvenement.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageSupprimerEvenement = () => {
  const [evenements, setEvenements] = useState([]);

  useEffect(() => {
    const chargerEvenements = async () => {
      try {
        const res = await axiosInstance.get('/api/evenements');
        setEvenements(res.data);
      } catch (err) {
        console.error("Erreur lors du chargement des événements :", err);
      }
    };
    chargerEvenements();
  }, []);

  const supprimerEvenement = async (id) => {
    try {
      await axiosInstance.delete(`/api/evenements/${id}`);
      setEvenements(evenements.filter(evt => evt._id !== id));
    } catch (err) {
      console.error("Erreur lors de la suppression :", err);
    }
  };

  // Regrouper les événements par date
  const evenementsParDate = evenements.reduce((acc, evt) => {
    const date = evt.date.split('T')[0];
    if (!acc[date]) acc[date] = [];
    acc[date].push(evt);
    return acc;
  }, {});

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Supprimer un événement</h1>

      {Object.keys(evenementsParDate).length === 0 ? (
        <p className="text-center">Aucun événement à afficher.</p>
      ) : (
        Object.entries(evenementsParDate).map(([date, evts]) => (
          <div key={date} className="mb-8">
            <h2 className="text-xl font-semibold mb-3">{new Date(date).toLocaleDateString()}</h2>
            <ul className="space-y-4">
              {evts.map(evt => (
                <li key={evt._id} className="bg-white border p-4 rounded shadow">
                  <h3 className="font-bold text-lg">{evt.titre}</h3>
                  <p>{evt.description}</p>
                  <a
                    href={evt.lien}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline block mb-2"
                  >
                    Voir l'événement
                  </a>
                  <button
                    onClick={() => supprimerEvenement(evt._id)}
                    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                  >
                    Supprimer
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
};

export default PageSupprimerEvenement;
